import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export type ApiMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

@Injectable({
  providedIn: 'root',
})
export class ApiMethodService {

  constructor(private http: HttpClient) {}

  /**
   * ✅ ฟังก์ชัน Template สำหรับส่ง API
   * - รองรับทุก Method (GET, POST, PUT, DELETE, PATCH)
    * - ใส่ Header ได้
   * - ใส่ Body / Params ได้
   * - Log อัตโนมัติ
   */
  request<T>(
    functionUrl: string,
    method: ApiMethod,
    baseUrl: string,
    options: {
      body?: any;
      params?: Record<string, string | number | boolean>; // ถ้าหลายตัว { key: value , key2: value2 }
      headers?: Record<string, string>;
      headerOnly: boolean;
      isConsoleLog : boolean;
      labelLog : string;
    } = {
      isConsoleLog: true,
      labelLog: '',
      headerOnly: false
    }
  ): Observable<T> {
    const url = `${baseUrl}${functionUrl}`;

    // ✅ ตั้ง Header
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    });

    // ✅ ตั้ง Params (ใช้ HttpParams)
    let httpParams = new HttpParams();
    if (options.params) {
      Object.entries(options.params).forEach(([key, value]) => {
        httpParams = httpParams.set(key, String(value));
      });
    }

    const config = {
      headers: httpHeaders,
      params: httpParams,
      body: options.body,
      withCredentials: true,
    };

    const label = `📦 Sent API [${options.labelLog}] | ${method}  : \n`;
    if (options.isConsoleLog) {
     if ( options.params && Object.keys(options.params).length > 0 ){
        console.log(
          label,
          url,
          "\n*** [ Headers ] ***   \n",
          config.headers,
          '\n\n *** [ params ] ***  \n',
          config.params.toString().split('&').map( p => decodeURIComponent(p) ) ,
          '\n' ,
        )

      }
      else if ( options.headerOnly ){
        console.log(
          label,
          url,
          '\n\n *** [ Headers Only ] *** \n',
          config.headers ,
        )
      }
      else {
        console.log(
          label,
          url,
          "\n*** [ Headers ] ***   \n",
          config.headers,
          '\n\n *** [ body ] *** \n',
          config.body ,
          '\n *** [ body ( JSON ) ] *** \n' ,
          JSON.stringify( config.body , null, 2 )
        )
      }
    }

    // ✅ เรียก Http ตาม method
    switch (method) {
      case 'GET':
        return this.http.get<T>(url, config);
      case 'POST':
        return this.http.post<T>(url, config.body, config);
      case 'PUT':
        return this.http.put<T>(url, config.body, config);
      case 'PATCH':
        return this.http.patch<T>(url, config.body, config);
      case 'DELETE':
        return this.http.delete<T>(url, config);
      default:
        throw new Error(`❌ Unsupported method: ${method}`);
    }
  }
}
